import { IconPropsType } from '..';

export const SlotIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.00001 8.40003H3.00001C2.48717 8.40003 2.0645 8.8118 2.00673 9.34229L2 9.4667V12.6667C2 13.2137 2.38604 13.6646 2.88338 13.7262L3.00001 13.7334H5.00001V8.40003ZM9.00001 8.40003H6.00001V13.7334H9.00001V8.40003ZM12 8.40003H10V13.7334H12C12.5522 13.7334 13.0001 13.2558 13.0001 12.6667V9.4667C13.0001 8.87759 12.5522 8.40003 12 8.40003ZM16.0001 12.6667C16.0001 13.2558 15.5522 13.7334 15 13.7334V15.8668C15 17.0449 14.1046 18 13.0001 18H2C0.895433 18 0 17.0449 0 15.8668V6.26668C0 5.08847 0.895433 4.13334 2 4.13334L3.75745 4.13387C4.56467 2.84719 5.93958 2 7.50001 2C9.06043 2 10.4353 2.84719 11.2426 4.13387L13.0001 4.13334C14.1046 4.13334 15 5.08847 15 6.26668V8.40003C15.5522 8.40003 16.0001 8.87759 16.0001 9.4667V10.5334H17.5001C17.7762 10.5334 18 10.2946 18 10L18.0004 7.24242C17.4176 7.02287 17 6.43011 17 5.73334C17 4.84968 17.6716 4.13334 18.5 4.13334C19.3284 4.13334 20 4.84968 20 5.73334C20 6.42972 19.5829 7.02218 19.0007 7.24205L19.0001 10.5334C19.0001 11.1225 18.5523 11.6 18 11.6H16.0001V12.6667Z"
    />
  </svg>
);
